import React from 'react';
import { PriceValue as StyledPriceValue } from './PriceValue.styled';

export interface PriceValueProps {
  children: React.ReactNode;
  className?: string;
}

export function PriceValue({ children, className }: PriceValueProps) {
  return (
    <StyledPriceValue className={className}>
      {children}
    </StyledPriceValue>
  );
}
